import { useEffect, useState } from "react";
import axios from "../helpers/axios";

export const createNewProduct = async (values, callback) => {
  const res = await axios.post(`/product/createproduct`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const updateProduct = async (id, values, callback) => {
  const res = await axios.put(`/product/updateproduct/${id}`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const deleteProduct = async (id, userid, callback) => {
  const res = await axios.put(`/product/deleteproduct/${id}`, { updatedBy: userid });

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const getAllProducts = async (rowPerPage, pageNumber, search, callback) => {
  const res = await axios.get(`/product/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);
  if (res.status === 200) {
    const productList = res.data.response.data;
    callback(productList);
  } else {
    callback(res.data.response);
  }
};

export const getProductByCategory = async (id, callback) => {
  const res = await axios.get(`/product/basedcat/${id}`);

  if (res.status === 200) {
    const productList = res.data.response;
    callback(productList);
  } else {
    callback(res.data.response);
  }
};

export const getProductList = async (callback) => {
  const res = await axios.get(`/product/productlist`);

  if (res.status === 200) {
    const productList = res.data.response;
    callback(productList);
  } else {
    callback(res.data.response);
  }
};

export const getProductById = async (id, callback) => {
  axios.get(`/product/${id}`).then((res) => {
    if (res.status === 200) {
      callback(res.data.response.data);
    } else {
      callback(res.data.response.data);
    }
  });
};

export const ProductAPI = () => {
  const [products, setProducts] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [productDetail, setProductDetail] = useState({});
  const [productListByCat, setProductListByCat] = useState([]);

  const [rowPerPage, setRowPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [callback, setCallback] = useState(false);
  const [id, setId] = useState(0);
  const [productCatId, setProductCatId] = useState(0);

  useEffect(() => {
    getAllProducts(rowPerPage, pageNumber, search, (res) => {
      setProducts(res);
      setTotalPages(res.totalPage || 1);
    });

    getProductById(id, (res) => {
      setProductDetail(res);
    });

    getProductByCategory(productCatId, (res) => {
      setProductListByCat(res);
    });

    getProductList((res) => {
      setProductsList(res);
    });
  }, [callback, rowPerPage, search, pageNumber, id, productCatId]);

  return {
    products: [products, setProducts],
    productsList: [productsList, setProductsList],
    productDetail: [productDetail, setProductDetail],
    productListByCat: [productListByCat, setProductListByCat],
    id: [id, setId],
    productCatId: [productCatId, setProductCatId],
    rowPerPage: [rowPerPage, setRowPerPage],
    search: [setSearch],
    pageNumber: [pageNumber, setPageNumber],
    totalPages: [totalPages, setTotalPages],
    callback: [callback, setCallback],
  };
};
